// extracted by mini-css-extract-plugin
export default {"paginationContainer":"Pagination_paginationContainer__pX+XX","paginationLink":"Pagination_paginationLink__Wvtg2","paginationInfo":"Pagination_paginationInfo__05a5q"};